<template lang="html">
	<form class="form-ui column default-form-ui" novalidate>
		<div class="title">
			Documents liés à l'opération
		</div>
		<div class="ctn-docs row">
			<div class="ctn-doc">
				<div class="tile-doc row">
					<span class="icon-document-pdf"></span>
					<div class="text">
						<div class="label">
							Lettre de Mission
						</div>
						<div class="name">
							{{ (letterOfMission) ? letterOfMission.original_name + '.pdf' : 'Pas de fichier' }}
						</div>
					</div>
					<input id="lmfile" type="file" class="hidden" @change="uploadLetterMissionFile">
				</div>
				<div class="ctn-actions row">
					<div class="btn btn-red ctn-icon" v-if="needForSign(letterOfMission)" @click="askForSignature(letterOfMission)">
						Soumettre une signature
					</div>
					<div class="btn btn-red ctn-icon" v-if="canLoad(letterOfMission)" @click="procUpload('lmfile')">
						<span class="icon-button-download"></span>
						Charger un fichier
					</div>
					<div class="status row" v-if="letterOfMission && !needForSign(letterOfMission)">
						Ajouté le {{ letterOfMission.universign_launch_date.split(' ')[0] }}
						<span class="green inner-status" v-if="letterOfMission.universign_status === 'completed'">Signé le {{ letterOfMission.signature_date.split(' ')[0] }}</span>
						<span class="orange inner-status" v-if="letterOfMission.universign_status === 'ready'">Signature en attente</span>
					</div>
				</div>
				<div class="other-actions row" v-if="letterOfMission">
					<div class="link" v-if="letterOfMission.universign_status === 'ready'" @click="callVerify(letterOfMission)">
						Vérifier
					</div>
					<div class="link" v-if="letterOfMission.universign_status === 'ready'" @click="relaunchTransaction(letterOfMission)">
						Envoyer un mail de relance
					</div>
				</div>
			</div>
			<div class="ctn-doc">
				<div class="tile-doc row">
					<span class="icon-document-pdf"></span>
					<div class="text">
						<div class="label">
							Rapport de Mission
						</div>
						<div class="name">
							{{ (rapportOfMission) ? rapportOfMission.original_name + '.pdf' : 'Pas de fichier' }}
						</div>
					</div>
					<input id="rmfile" type="file" class="hidden" @change="uploadCRFile">
				</div>
				<div class="ctn-actions row">
					<div class="btn btn-red ctn-icon" v-if="needForSign(rapportOfMission)" @click="askForSignature(rapportOfMission)">
						Soumettre une signature
					</div>
					<div class="btn btn-red ctn-icon" v-if="canLoad(rapportOfMission)" @click="procUpload('rmfile')">
						<span class="icon-button-download"></span>
						Charger un fichier
					</div>
					<div class="status row" v-if="rapportOfMission && !needForSign(rapportOfMission)">
						Ajouté le {{ rapportOfMission.universign_launch_date.split(' ')[0] }}
						<span class="green inner-status" v-if="rapportOfMission.universign_status === 'completed'">Signé le {{ rapportOfMission.signature_date.split(' ')[0] }}</span>
						<span class="orange inner-status" v-if="rapportOfMission.universign_status === 'ready'">Signature en attente</span>
					</div>
				</div>
				<div class="other-actions row" v-if="rapportOfMission">
					<div class="link" v-if="rapportOfMission.universign_status === 'ready'" @click="callVerify(rapportOfMission)">
						Vérifier
					</div>
					<div class="link" v-if="rapportOfMission.universign_status === 'ready'" @click="relaunchTransaction(rapportOfMission)">
						Envoyer un mail de relance
					</div>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import UniversignResource from '@/common/resources/Universign'
import TileDoc from '@/common/components/tile-doc'

export default {
	name: 'EditDocs',
	props: ['operation'],
	components: {
		TileDoc
	},
	data () {
		return {
			letterOfMission: null,
			rapportOfMission: null
		}
	},
	mounted () {
		this.initOperationDocuments()
	},
	methods: {
		initOperationDocuments () {
			this.operation.documents.forEach((doc) => {
				if (doc.sub_category === 'Lettre de mission') {
					if (this.letterOfMission) {
						this.letterOfMission = (doc.id >= this.letterOfMission.id) ? doc	: this.letterOfMission
					} else {
						this.letterOfMission = doc
					}
				} else if (doc.sub_category === 'Rapport de mission') {
					if (this.rapportOfMission) {
						this.rapportOfMission = (doc.id >= this.rapportOfMission.id) ? doc	: this.rapportOfMission
					} else {
						this.rapportOfMission = doc
					}
				}
			})
		},
		uploadLetterMissionFile (e) {
			let file = e.target.files[0]
			let type = this.resolveType(file.type)
			if (type) {
				this.$store.dispatch('addDocument', {
					mission_id: this.operation.id,
					user_id: this.operation.client.user.id,
					category: 'operations',
					type: file.type.replace('application/', ''),
					file: file,
					subcategory: 'Lettre de mission',
					signature_required: true,
					signature_token: null,
					original_name: this.operation.title + '_lettre_de_mission',
					confidential: 0
				}).then(() => {
					this.$emit('needToUpdate')
					this.$notify({
						type: 'success',
						group: 'default',
						title: 'Lettre de mission ajouté avec succès',
						text: ''
					})
				}).catch(() => {
					this.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez réessayer'
					})
				})
			}
		},
		canLoad (doc) {
			return !doc || (doc.universign_status === 'null' || doc.universign_status === undefined)
		},
		needForSign (doc) {
			return doc && (doc.universign_status === 'null' || doc.universign_status === undefined)
		},
		uploadCRFile (e) {
			let file = e.target.files[0]
			let type = this.resolveType(file.type)
			if (type) {
				this.$store.dispatch('addDocument', {
					mission_id: this.operation.id,
					user_id: this.operation.client.user.id,
					category: 'operations',
					type: file.type.replace('application/', ''),
					file: file,
					subcategory: 'Rapport de mission',
					signature_required: true,
					signature_token: null,
					original_name: this.operation.title + '_rapport_de_mission',
					confidential: 0
				}).then(() => {
					this.$emit('needToUpdate')
					this.$notify({
						type: 'success',
						group: 'default',
						title: 'Rapport de mission ajouté avec succès',
						text: ''
					})
				}).catch(() => {
					this.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez réessayer'
					})
				})
			}
		},
		procUpload (id) {
			document.getElementById(id).click()
		},
		resolveType (t) {
			let value = null
			switch (t) {
			case 'application/pdf':
				value = 'pdf'
				break
			case 'application/octet-stream':
				value = 'txt'
				break
			case 'application/msword':
				value = 'doc'
				break
			case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
				value = 'docx'
				break
			case 'application/vnd.ms-excel':
				value = 'xls'
				break
			case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
				value = 'xlsx'
				break
			default:
				value = false
			}

			return value
		},
		askForSignature (doc) {
			const func = (doc === this.letterOfMission) ? UniversignResource.signMissionLetter : UniversignResource.signMissionReport
			const id = doc.id

			func(id).then((result) => {
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Demande de signature envoyé avec succès',
					text: 'Un mail a été envoyé à votre client'
				})
				this.$emit('needToUpdate')
			}).catch((error) => {
				console.warn(error)
			})
		},
		callVerify (doc) {
			this.$store.commit('LOADER_IN')
			UniversignResource.verify(doc.universign_transaction_id).then((result) => {
				this.$store.commit('LOADER_OUT')
				if (result.data.success) {
					doc.universign_status = result.data.universign_status
				}
			}).catch((error) => {
				this.$store.commit('LOADER_OUT')
				console.warn(error)
			})
		},
		relaunchTransaction (doc) {
			this.$store.commit('LOADER_IN')
			UniversignResource.relaunchTransaction(doc.universign_transaction_id).then((result) => {
				this.$store.commit('LOADER_OUT')
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Mail de relance envoyé avec succès',
					text: ''
				})
			}).catch((error) => {
				this.$store.commit('LOADER_OUT')
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: ''
				})
				console.warn(error)
			})
		}
	},
	watch: {
		operation () {
			this.initOperationDocuments()
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Docs.vue?f76edd1a